import { render, staticRenderFns } from "./MenuShortcutsPage.vue?vue&type=template&id=2816c861&scoped=true"
import script from "./MenuShortcutsPage.vue?vue&type=script&lang=js"
export * from "./MenuShortcutsPage.vue?vue&type=script&lang=js"
import style0 from "./MenuShortcutsPage.vue?vue&type=style&index=0&id=2816c861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816c861",
  null
  
)

export default component.exports